import React from "react";

function Menu() {
  const items = [
    { name: "Fresh Crabs", price: "$25/kg", img: "https://images.unsplash.com/photo-1604908177522-432c64809d61" },
    { name: "Lobsters", price: "$40/kg", img: "https://images.unsplash.com/photo-1598514982586-4a23f5cf0c7e" },
    { name: "Prawns", price: "$18/kg", img: "https://images.unsplash.com/photo-1617196038658-46b2dd8f04fb" },
    { name: "Fish Fillets", price: "$15/kg", img: "https://images.unsplash.com/photo-1588167056545-930021f9c3d0" },
  ];

  return (
    <div className="p-10">
      <h2 className="text-3xl font-bold text-blue-900 mb-6">Our Menu</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((item, index) => (
          <div key={index} className="bg-white rounded-2xl shadow-lg p-4">
            <img src={item.img} alt={item.name} className="rounded-xl w-full h-48 object-cover" />
            <h3 className="text-xl font-semibold mt-2">{item.name}</h3>
            <p className="text-gray-600">{item.price}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Menu;
